import { render, staticRenderFns } from "./Registation.vue?vue&type=template&id=3361e596&"
import script from "./Registation.vue?vue&type=script&lang=js&"
export * from "./Registation.vue?vue&type=script&lang=js&"
import style0 from "./Registation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports